import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      const label = this.props.name;
      return (
        <div style={{ padding: 24, textAlign: 'center' }} data-testid="error-boundary-fallback">
          <p style={{ color: '#657161', fontWeight: 600, marginBottom: 8 }}>
            {label ? `Esta secção (${label}) encontrou um erro` : 'Esta secção encontrou um erro'}
          </p>
          <p style={{ color: '#7A8276', fontSize: 13 }}>
            As outras áreas continuam a funcionar, usa o menu para navegar. Podes também tentar novamente.
          </p>
          <button onClick={() => this.setState({ hasError: false, error: null })} style={{ marginTop: 12, padding: '8px 20px', background: '#657161', color: 'white', border: 'none', borderRadius: 20, cursor: 'pointer', fontSize: 13 }}>
            Tentar novamente
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
